stimulusApp.register(
  "property-map-popup",
  class extends Stimulus.Controller {
    static outlets = ["search-map-list"]

    connect() {
      this.config = HB.mapHelpers.buildConfig()
      this.markerManager = null // Initialize markerManager

      // 2. Ensure Google Maps JS is loaded, then boot
      HB.mapHelpers
        .loadGoogleMaps(this.config.js_libs.google_maps_url)
        .then(async () => {
          await HB.loadJS(this.config.js_libs.snazzy_info_window_path, "module")

          this.initMap()
        })

      Activity.track("map", "open")
    }

    disconnect() {
      Activity.track("map", "close")
      this.markerManager?.destroy()
      this.markerManager = null
    }

    getSearchMapList() {
      return {
        outlet: this.searchMapListOutlet,
        hasOutlet: !!this.hasSearchMapListOutlet,
      }
    }

    initMap() {
      const options = $.extend(
        true,
        {},
        HB.mapHelpers.defaultMapOptions(),
        this.config.map_options,
      )

      this.map = new google.maps.Map(this.element, options)

      this.markerManager = new HB.PropertyMapMarkerManager({
        map: this.map,
        config: this.config,
        outletFn: this.getSearchMapList.bind(this),
      })

      this.map.addListener("zoom_changed", () => {
        this.markerManager.closeAllInfoWindows()
      })

      // The marker manager handles its own "idle" listener for after-initial fetching
      google.maps.event.addListenerOnce(this.map, "idle", () =>
        this.markerManager.initializeMarkers(),
      )

      document
        .querySelector(".gmap-types-switcher")
        ?.style.setProperty("display", "block")

      window.HB.initMapTypesSwitcher(this.map)
    }
  },
)
